module.exports = __webpack_public_path__ + "static/media/card.424b1d72.svg";